import { ChangeEvent, ClipboardEvent, FunctionComponent } from 'react';
import classnames from 'classnames';

import InputWrapper from 'components/layout/forms/InputWrapper';

import StyledComponent from './styles';
import { Props } from './types';

const LayoutFormsInput: FunctionComponent<Props> = ({
    className,
    name,
    label,
    type,
    placeholder,
    value,
    onChange,
    style,
    styles,
    disabled,
    error,
    decoratorLeft,
    decoratorRight,
}) => {
    return (
        <StyledComponent
            className={classnames(
                'layout-forms-input',
                [
                    `style-${style}`,
                    `name-${name}`,
                    className,
                ],
                {
                    'error': Boolean(error),
                    'decorator-left': Boolean(decoratorLeft && decoratorLeft.visible !== false),
                    'decorator-right': Boolean(decoratorRight && decoratorRight.visible !== false),
                }
            )}
            style={styles}
        >
            <InputWrapper
                label={label}
                error={error}
                decoratorLeft={decoratorLeft}
                decoratorRight={decoratorRight}
                disabled={disabled}
                type={type}
            >
                <input
                    className="input"
                    name={name}
                    type={type}
                    placeholder={placeholder}
                    autoComplete="none"
                    value={value === null ? '' : value}
                    onChange={(event: ChangeEvent<HTMLInputElement>) => onChange(event)}
                    onPaste={(event: ClipboardEvent<HTMLInputElement>): void => onChange(event)}
                    disabled={disabled}
                />
            </InputWrapper>
        </StyledComponent>
    );
};

export default LayoutFormsInput;
